import { render } from "./SurveyQuestions.vue?vue&type=template&id=e205452a&scoped=true"
import script from "./SurveyQuestions.vue?vue&type=script&lang=js"
export * from "./SurveyQuestions.vue?vue&type=script&lang=js"

import "./SurveyQuestions.vue?vue&type=style&index=0&id=e205452a&lang=scss&scoped=true"

import exportComponent from "/src/clientapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e205452a"]])

export default __exports__